export const NEED_COMPLETE = 'CUSTOM_ERROR_NEED_COMPLETE';

export const customErrorMsgMap = {
    [NEED_COMPLETE]: __('当前银行账户信息不完整，请补全收款信息或选择其他账户收款。')
};
